import React, { useState } from 'react';

const animation = {
	transition: "opacity 0.3s ease-in"
}

export const SmoothImage = function ({ style, alt, ...rest}) {
	const [loaded, setLoader] = useState(0)
	const injectedStyle = { ...style, ...animation, opacity: loaded}
	return (
	<img alt={alt || "Smooth image alt"}  style={injectedStyle} {...rest}
			 onLoad={()=> setLoader(1)}/>
	);
}
